import mitt, { Emitter } from 'mitt';

import { ClientType } from './types';

enum EventTypes {
  ActiveClient = 'activeClient',
  AuthError = 'authError',
  ClientInitialized = 'clientInitialized',
}

type Events = {
  [EventTypes.ActiveClient]: ClientType;
  [EventTypes.AuthError]: string;
  [EventTypes.ClientInitialized]: ClientType;
};

const emitter: Emitter<Events> = mitt<Events>();

export { emitter, EventTypes };
export type { Events };
